import {
  collection,
  getDocs,
  query,
  where,
  writeBatch,
} from "firebase/firestore";
import { map } from "rxjs";
import { DBFactory } from "~/classes/database/db_factory";
import { RevisionEditHistory } from "./revision-history-edit.model";

export class SubmittedDocumentsService {
  static async archiveUserUngradedDocuments(userId: string) {
    const db = useFirestore();
    const documentsRef = collection(db, "/documents");
    const documentsQuery = query(
      documentsRef,
      where("userId", "==", userId),
      where("state", "not-in", [
        DocumentState.archived,
        DocumentState.graded,
        DocumentState.ignored,
      ])
    );

    const snapshot = await getDocs(documentsQuery);
    const docs = snapshot.docs;

    const batch = writeBatch(db);

    docs.forEach((doc) => {
      batch.update(doc.ref, { state: DocumentState.archived });
    });

    await batch.commit();
  }

  static streamEditingHistory({
    submittedDocumentId,
    revisionId,
  }: {
    submittedDocumentId: string;
    revisionId: string;
  }) {
    const db = DBFactory.createDatabase();
    return db
      .streamList({
        collection: `/documents/${submittedDocumentId}/revisions/${revisionId}/editingHistory`,
        path: `/documents/${submittedDocumentId}/revisions/${revisionId}/editingHistory`,
      })
      .pipe(
        map((data) => {
          return data.map((doc) => {
            return RevisionEditHistory.fromMap(doc);
          });
        })
      );
  }

  static async fetchEditingHistoryPage({
    submittedDocumentId,
    revisionId,
    limitCount = 20,
    beforeTimestamp,
  }: {
    submittedDocumentId: string;
    revisionId: string;
    limitCount?: number;
    beforeTimestamp?: number;
  }) {
    const db = DBFactory.createDatabase();
    const queryConfig = [
      ...(beforeTimestamp != undefined
        ? [
            {
              type: "where" as const,
              field: "lastUpdatedTimestamp",
              operator: "<" as const,
              value: beforeTimestamp,
            },
          ]
        : []),
      {
        type: "orderBy" as const,
        field: "lastUpdatedTimestamp",
        direction: "desc" as const,
      },
      {
        type: "limit" as const,
        value: limitCount,
      },
    ];

    const data = await db.list(
      {
        collection: `/documents/${submittedDocumentId}/revisions/${revisionId}/editingHistory`,
        path: `/documents/${submittedDocumentId}/revisions/${revisionId}/editingHistory`,
      },
      queryConfig
    );

    return data.map((doc) => {
      return RevisionEditHistory.fromMap(doc);
    });
  }
}
